import React from 'react';
import PasswordStrengthHint from './PasswordStrengthHint';

export default function ResetPassword({
  form,
  setForm,
  onSubmit,
  onBackToLogin,
  error,
  loading,
  success,
}) {
  if (success) {
    return (
      <div className="auth-view">
        <div className="hero">
          <h2>Password reset ✓</h2>
          <p>Your password has been updated. You can sign in now with your new password.</p>
        </div>
        <button className="generate-btn ready" onClick={onBackToLogin}>
          <span className="btn-icon"></span>
          <span className="btn-text">Sign in</span>
        </button>
      </div>
    );
  }

  return (
    <div className="auth-view">
      <div className="hero">
        <h2>Set a new password</h2>
        <p>Choose a strong password — the checklist below shows what's required.</p>
      </div>

      <form className="auth-form" onSubmit={onSubmit}>
        <div className="auth-field">
          <label>New password</label>
          <input
            type="password"
            autoComplete="new-password"
            placeholder="At least 10 characters"
            value={form.newPassword}
            onChange={(e) => setForm({ ...form, newPassword: e.target.value })}
            required
            minLength={10}
          />
          <PasswordStrengthHint value={form.newPassword} />
        </div>

        <div className="auth-field">
          <label>Confirm new password</label>
          <input
            type="password"
            autoComplete="new-password"
            placeholder="Re-enter password"
            value={form.confirmPassword}
            onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
            required
            minLength={10}
          />
        </div>

        {error && (
          <div className="error-message">
            <span></span> {error}
          </div>
        )}

        <button type="submit" className="generate-btn ready" disabled={loading}>
          <span className="btn-icon"></span>
          <span className="btn-text">{loading ? 'Updating…' : 'Update password'}</span>
        </button>
      </form>

      <button className="auth-toggle" onClick={onBackToLogin}>
        ← Back to sign in
      </button>
    </div>
  );
}
